import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect, useState } from "react";
import data from "../../src/component/ApiUrl/meta_api";
import { Helmet } from "react-helmet";

function Schneider() {
  const [meta, setMeta] = useState(null);

  const fetchData = () => {
    const SchneiderMeta = data[0]?.Schneider_page;
    if (SchneiderMeta) {
      setMeta(SchneiderMeta);
    }
  };
  useEffect(() => {
    fetchData();
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);

  return (
    <>
      {/* Page Header */}
      <div className="container-fluid page-header py-5  animate__animated animate__fadeIn">
        <Helmet>
          <title>{meta ? meta.title : "Schneider - SKimitar Hindustan"}</title>
          <meta
            name="description"
            content="Learn about Skimitar Hindustan's PLC,HMI and Variable Frequency Drives in industrial automation solutions."
          />
        </Helmet>
        <div className="container py-5">
          <h1 className="display-3 text-white animate__animated animate__slideInRight">
            Schneider
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb animate__animated animate__slideInRight mb-0">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/">Products</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Schneider
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <section className="py-5 bg-light position-relative overflow-hidden">
        {/* Decorative elements */}

        <div className="container position-relative" style={{ zIndex: 1 }}>
          <div className="row justify-content-center">
            <div className="col-12 col-lg-8 text-center">
              <h1
                className="text-gradient-primary fw-bold fs-2 mb-4"
                data-aos="fade-left"
              >
                Empowering Industries with Intelligent Automation
              </h1>
            </div>
          </div>

          {/* Content Section */}
          <div className="row align-items-center g-5">
            <div
              className="col-lg-6 col-md-6 order-md-1 order-2"
              data-aos="fade-right"
            >
              <div className="pe-lg-5">
                <p className="fs-6 mb-4 justified-text">
                  At Scimitar Automation, we provide cutting-edge Schneider
                  Electric industrial automation products to help businesses
                  achieve efficiency, reliability, and sustainability.
                </p>
                <p className="fs-6 justified-text">
                  As a trusted provider, we offer a comprehensive range of
                  Schneider solutions, including PLCs, HMIs, SCADA, drives, and
                  industrial control products tailored for various industries.
                </p>
              </div>
            </div>

            <div
              className="col-lg-6 col-md-6 order-md-2 order-1"
              data-aos="fade-left"
            >
              <div className="position-relative">
                <img
                  className="img-fluid rounded-4 shadow-lg"
                  src={require("../assets/img/products/Schneider/Industrial Software Software solutions for -monitoring-1.png")}
                  alt="Industrial Automation Solutions"
                  style={{
                    transform: "perspective(1000px) rotateY(-5deg)",
                    border: "1px solid rgba(0,0,0,0.1)",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="schneider-products  bg-light">
        <div className="container">
          <h2
            className="text-gradient-primary text-center fw-bold fs-2 mb-4"
            data-aos="fade-left"
          >
            Our Schneider Product Range
          </h2>

          {/* Product Item 1 */}
          <div className="row align-items-center g-5 mb-5">
            <div className="col-lg-6 col-md-6" data-aos="fade-left">
              <div className="product-details p-4 bg-white rounded-3 shadow-sm h-100">
                <h3 className="text-danger mb-4 fs-3 fw-bold">
                  Programmable Logic Controllers (PLCs)
                </h3>
                <h5 className="mb-3 text-secondary">Modicon Series PLCs</h5>

                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="product-model p-3 bg-light rounded-2">
                      <h6 className="fw-bold">Modicon M221, M241, M251</h6>
                      <p className="fs-6 mb-0">
                        Compact and efficient controllers for small to medium
                        automation applications.
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="product-model p-3 bg-light rounded-2">
                      <h6 className="fw-bold">Modicon M262</h6>
                      <p className="fs-6 mb-0">
                        High-performance PLC with embedded cybersecurity and
                        IIoT capabilities.
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="product-model p-3 bg-light rounded-2">
                      <h6 className="fw-bold">Modicon M580 (ePAC)</h6>
                      <p className="fs-6 mb-0">
                        Advanced Ethernet-based PLC for large-scale industrial
                        automation.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mt-4">
                  <h5 className="text-secondary mb-3">
                    Key Features & Benefits
                  </h5>
                  <ul className="list-unstyled">
                    <li className="mb-2 d-flex align-items-start">
                      <span className="badge bg-danger me-2 mt-1">
                        <i className="fas fa-check"></i>
                      </span>
                      <span>
                        High-Speed Processing - Ensures faster execution for
                        critical automation tasks.
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-start">
                      <span className="badge bg-danger me-2 mt-1">
                        <i className="fas fa-check"></i>
                      </span>
                      <span>
                        Ethernet & IIoT Connectivity - Supports seamless
                        communication with industrial networks.
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-start">
                      <span className="badge bg-danger me-2 mt-1">
                        <i className="fas fa-check"></i>
                      </span>
                      <span>
                        Modular Expansion for Scalability - Easily upgrade or
                        expand based on project needs.
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-start">
                      <span className="badge bg-danger me-2 mt-1">
                        <i className="fas fa-check"></i>
                      </span>
                      <span>
                        Integrated Cybersecurity - Built-in protection against
                        cyber threats.
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-start">
                      <span className="badge bg-danger me-2 mt-1">
                        <i className="fas fa-check"></i>
                      </span>
                      <span>
                        Energy Efficiency - Optimized power consumption for
                        sustainable automation.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6" data-aos="fade-right">
              <div className="product-image-container p-3 bg-white rounded-3 shadow-sm">
                <img
                  className="img-fluid rounded-3"
                  src={require("../assets/img/products/Schneider/Our Schneider Product Range Programmable Logic Controllers (PLCs) Modicon Series.png")}
                  alt="Schneider Programmable Logic Controllers"
                />
              </div>
            </div>
          </div>

          {/* Additional product items would follow the same pattern */}
        </div>
      </section>

      <div className="container-fluid ">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-12 text-center ">
              {/* <span className="badge bg-danger rounded-pill px-4 py-2 mb-3 fw-normal">Human Machine Interfaces</span> */}

              <h2
                className="text-gradient-primary fw-bold fs-2 mt-2 mb-4"
                data-aos="fade-left"
              >
                Harmony HMI Series
              </h2>
              <div
                className="divider mx-auto bg-danger"
                style={{ height: "3px", width: "80px" }}
              ></div>
            </div>

            <div className="col-lg-6" data-aos="zoom-in-right">
              <div className="position-relative overflow-hidden rounded-4 shadow-lg">
                <img
                  className="img-fluid w-100"
                  src={require("../assets/img/products/Schneider/Harmony HMI Series Harmony HM.png")}
                  alt="Harmony HMI Series"
                />
              </div>
            </div>

            <div className="col-lg-6" data-aos="zoom-out">
              <div className=" rounded-4 h-100">
                <div className="row g-3 mb-1">
                  <div className="col-md-6">
                    <div className="d-flex">
                      <div className="me-3 text-danger">
                        <i className="bi bi-check-circle-fill fs-4"></i>
                      </div>
                      <p className="fs-6 mb-0">
                        Harmony ST6, GXU, GTU: Touchscreen panels with intuitive
                        interfaces
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex">
                      <div className="me-3 text-danger">
                        <i className="bi bi-check-circle-fill fs-4"></i>
                      </div>
                      <p className="fs-6 mb-0">
                        Magelis Series: High-resolution displays with advanced
                        visualization
                      </p>
                    </div>
                  </div>
                </div>

                <h5 className="text-black mt-3 mb-3 fw-bold">
                  Key Features & Benefits
                </h5>

                <div className="row g-3">
                  <div className="col-md-6">
                    <div className=" card bg-opacity-50 p-3 rounded-3 h-100">
                      <div className="d-flex align-items-center mb-2">
                        <span className="bg-danger bg-opacity-10 text-danger rounded-circle p-2 me-2">
                          <i className="bi bi-display"></i>
                        </span>
                        <h6 className="mb-0 fw-bold">
                          High-Resolution Touchscreen
                        </h6>
                      </div>
                      <p className="fs-6 mb-0 small">
                        Clear and responsive display for enhanced user
                        interaction
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className=" card bg-opacity-50 p-3 rounded-3 h-100">
                      <div className="d-flex align-items-center mb-2">
                        <span className="bg-danger bg-opacity-10 text-danger rounded-circle p-2 me-2">
                          <i className="bi bi-hand-index-thumb"></i>
                        </span>
                        <h6 className="mb-0 fw-bold">Multi-Touch Capability</h6>
                      </div>
                      <p className="fs-6 mb-0 small">
                        Supports gesture controls for modern experience
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className=" card bg-opacity-50 p-3 rounded-3 h-100">
                      <div className="d-flex align-items-center mb-2">
                        <span className="bg-danger bg-opacity-10 text-danger rounded-circle p-2 me-2">
                          <i className="bi bi-shield-check"></i>
                        </span>
                        <h6 className="mb-0 fw-bold">
                          Industrial-Grade Durability
                        </h6>
                      </div>
                      <p className="fs-6 mb-0 small">
                        Designed for harsh environments with dust water
                        resistance
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card bg-opacity-50 p-3 rounded-3 h-100">
                      <div className="d-flex align-items-center mb-2">
                        <span className="bg-danger bg-opacity-10 text-danger rounded-circle p-2 me-2">
                          <i className="bi bi-plug"></i>
                        </span>
                        <h6 className="mb-0 fw-bold">Seamless Integration</h6>
                      </div>
                      <p className="fs-6 mb-0 small">
                        Compatible with EcoStruxure and other systems
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className=" card bg-opacity-50 p-3 rounded-3 h-100">
                      <div className="d-flex align-items-center mb-2">
                        <span className="bg-danger bg-opacity-10 text-danger rounded-circle p-2 me-2">
                          <i className="bi bi-phone"></i>
                        </span>
                        <h6 className="mb-0 fw-bold">
                          Remote Access & Control
                        </h6>
                      </div>
                      <p className="fs-6 mb-0 small">
                        Monitor and operate machines from anywhere
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className=" card bg-opacity-50 p-3 rounded-3 h-100">
                      <div className="d-flex align-items-center mb-2">
                        <span className="bg-danger bg-opacity-10 text-danger rounded-circle p-2 me-2">
                          <i className="bi bi-graph-up"></i>
                        </span>
                        <h6 className="mb-0 fw-bold">Advanced Data Logging</h6>
                      </div>
                      <p className="fs-6 mb-0 small">
                        Performance analysis and troubleshooting
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="container-fluid bg-gradient py-5"
        style={{
          background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
        }}
      >
        <div className="container">
          <div className="row g-4 align-items-center">
            {/* Text Content (Left Side) */}
            <div className="col-lg-6" data-aos="fade-right">
              <div
                className="p-4 p-lg-5 rounded-4 bg-white shadow-sm"
                style={{ border: "1px solid rgba(0,0,0,0.05)" }}
              >
                <h2
                  className="text-gradient-primary fw-bold fs-2 mb-4"
                  data-aos="fade-right"
                >
                  Variable Frequency Drives (VFDs)
                </h2>

                <ul className="list-unstyled mb-0">
                  <li className="mb-3 d-flex align-items-start">
                    <i className="bi bi-check-circle-fill text-danger me-3 fs-6"></i>
                    <span className="fs-6">
                      Altivar ATV12, ATV320: Ideal for simple motor control
                      applications.
                    </span>
                  </li>
                  <li className="mb-3 d-flex align-items-start">
                    <i className="bi bi-check-circle-fill text-danger me-3 fs-6"></i>
                    <span className="fs-6">
                      Altivar ATV630, ATV930: High-performance drives for energy
                      efficiency.
                    </span>
                  </li>

                  <li className="mb-2 d-flex align-items-center">
                    <i className="bi bi-arrow-right-circle text-danger me-2"></i>
                    <span>Smooth motor operation</span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <i className="bi bi-arrow-right-circle text-danger me-2"></i>
                    <span>Energy-efficient design</span>
                  </li>
                  <li className="d-flex align-items-center">
                    <i className="bi bi-arrow-right-circle text-danger me-2"></i>
                    <span>Advanced diagnostics & connectivity</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Image (Right Side) */}
            <div className="col-lg-6" data-aos="fade-left">
              <div className="position-relative overflow-hidden rounded-4 shadow-lg hover-effect">
                <img
                  className="img-fluid w-100 rounded-4"
                  src={require("../assets/img/products/Schneider/Variable Frequency Drives (VFDs) Altivar.png")}
                  alt="Variable Frequency Drives"
                  style={{ minHeight: "400px", objectFit: "cover" }}
                />
                <div className="position-absolute top-0 start-0 w-100 h-100  opacity-10"></div>

                {/* Optional: Image Badge */}
                {/* <div className="position-absolute bottom-0 end-0 m-4">
                  <span className="badge bg-danger bg-opacity-90 px-3 py-2 rounded-pill fs-6 shadow">
                    <i className="bi bi-lightning-charge-fill me-2"></i> High
                    Efficiency
                  </span>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mt-3 mb-5">
        {/* <div
          className="icon-lg bg-danger bg-opacity-10 text-danger rounded-circle d-inline-flex align-items-center justify-content-center mb-1"
          style={{ width: "60px", height: "60px" }}
        >
          <i className="bi bi-cpu fs-3"></i>
        </div> */}
        <h2 className="text-danger fw-bold mb-0">
          SCADA and Industrial Software
        </h2>
      </div>

      <div className="container ">
        <div
          className="card shadow-sm mb-5 p-4 p-lg-5 border-0 rounded-3"
          style={{ background: "linear-gradient(to right, #f8f9fa, #ffffff)" }}
        >
          {/* Header with icon */}

          <div className="row g-4">
            {/* Key Features Card */}
            <div className="col-lg-6">
              <div className="card h-100 border-0 rounded-3 overflow-hidden shadow-sm">
                <div className="card-header bg-white border-0">
                  <h4 className="fw-bold mb-0">
                    <i className="bi bi-check-circle text-danger me-2"></i>
                    Key Features
                  </h4>
                </div>
                <div className="card-body">
                  <ul className="list-unstyled mb-0">
                    {[
                      "EcoStruxure™ Machine SCADA Expert - Real-time data monitoring, control, and analytics",
                      "EcoStruxure™ Control Expert - Advanced PLC programming and simulation software",
                      "AVEVA Edge & System Platform - Scalable industrial SCADA solutions",
                      "Seamless integration with Schneider hardware",
                      "Advanced analytics and reporting",
                      "Cloud-based monitoring and IIoT connectivity",
                    ].map((item, index) => (
                      <li key={index} className="mb-2 d-flex">
                        <i className="bi bi-check2-circle text-danger mt-1 me-2 flex-shrink-0"></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {/* First Image Card */}
            <div className="col-lg-6">
              <div className="card h-100 border-0 rounded-3 overflow-hidden shadow-sm">
                <div
                  className="card-body p-0 d-flex align-items-center bg-light"
                  style={{ minHeight: "200px" }}
                >
                  <img
                    src={require("../assets/img/products/Schneider/SCADA and Industrial Software Key Features EcoStruxure.png")}
                    className="img-fluid w-100 object-fit-cover"
                    style={{ height: "300px" }}
                    alt="SCADA System"
                  />
                </div>
              </div>
            </div>

            {/* Second Image Card */}
            <div className="col-lg-6">
              <div className="card h-100 border-0 rounded-3 overflow-hidden shadow-sm">
                <div
                  className="card-body p-0 d-flex align-items-center bg-light"
                  style={{ minHeight: "200px" }}
                >
                  <img
                    src={require("../assets/img/products/Schneider/Control & Safety Solutions Contactors, Relays, and Push Buttons.png")}
                    className="img-fluid w-100 h-100 object-fit-cover"
                    alt="Industrial Control"
                  />
                </div>
                <div className="card-footer bg-white border-0 text-center py-2">
                  <small className="text-muted fw-medium">
                    <i className="bi bi-shield-check me-1"></i>
                    Industrial safety components
                  </small>
                </div>
              </div>
            </div>

            {/* Solutions Card */}
            <div className="col-lg-6">
              <div className="card h-100 border-0 rounded-3 overflow-hidden shadow-sm">
                <div className="card-header bg-white border-0">
                  <h4 className="fw-bold mb-0">
                    <i className="bi bi-shield-lock text-danger me-2"></i>
                    Control & Safety Solutions
                  </h4>
                </div>
                <div className="card-body">
                  <ul className="list-unstyled mb-3">
                    {[
                      "Contactors, Relays, and Push Buttons",
                      "Safety PLCs and Emergency Stop Solutions",
                      "Power Monitoring & Energy Management",
                      "Reliable industrial-grade components",
                    ].map((item, index) => (
                      <li key={index} className="mb-2 d-flex">
                        <i className="bi bi-check-square text-danger mt-1 me-2 flex-shrink-0"></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="bg-light p-3 rounded-2">
                    <h5 className="fw-bold mb-2 d-flex align-items-center">
                      {/* <i className="bi bi-stars text-warning me-2"></i> */}
                      Key Benefits
                    </h5>
                    <ul className="list-unstyled small">
                      <li className="mb-2 d-flex">
                        <i className="bi bi-arrow-right-short  mt-1 me-1"></i>
                        <span className="fs-6">
                          TeSys™ and Harmony™ series for durable switching
                          solutions
                        </span>
                      </li>
                      <li className="d-flex">
                        <i className="bi bi-arrow-right-short  mt-1 me-1"></i>
                        <span className="fs-6">
                          Modicon™ Safety PLCs with SIL3, PL e compliance
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* //////////////////////////////////////////////////////////////////////////////////////////////////// */}

      {/* Solutions Overview */}
      <section id="solutions" className="py-7 bg-light">
        <div className="container">
          <div className="text-center mb-7" data-aos="fade-up">
            {/* <span className="badge bg-danger bg-opacity-10 text-danger mb-3">
              OUR SOLUTIONS
            </span> */}
            <h2 className="display-6 fw-bold mb-4">
              Comprehensive{" "}
              <span className="text-danger">Schneider Electric</span> Portfolio
            </h2>
          </div>

          <div className="row g-4">
            <div
              className="col-md-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="card h-100 border-0 shadow-sm hover-lift">
                <div className="card-body p-4 text-center">
                  <div className="icon-lg   text-danger  mb-4 mx-auto">
                    <i className="fas fa-microchip"></i>
                  </div>
                  <h4 className="mb-3">PLCs & Controllers</h4>
                  <p className="fs-6 mb-0">
                    Modicon series PLCs for precise industrial control and
                    automation
                  </p>
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="card h-100 border-0 shadow-sm hover-lift">
                <div className="card-body p-4 text-center">
                  <div className="icon-lg  text-danger mb-4 mx-auto">
                    <i className="fas fa-tachometer-alt"></i>
                  </div>
                  <h4 className="mb-3">Variable Speed Drives</h4>
                  <p className="fs-6 mb-0">
                    Altivar drives for energy-efficient motor control
                  </p>
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div className="card h-100 border-0 shadow-sm hover-lift">
                <div className="card-body p-4 text-center">
                  <div className="icon-lg  text-danger mb-4 mx-auto">
                    <i class="fa-solid fa-wifi"></i>
                  </div>
                  <h4 className="mb-3">HMIs & SCADA</h4>
                  <p className="fs-6 mb-0">
                    Intuitive interfaces for real-time monitoring and control
                  </p>
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <div className="card h-100 border-0 shadow-sm hover-lift">
                <div className="card-body p-4 text-center">
                  <div className="icon-lg text-danger  mb-4 mx-auto">
                    <i className="fas fa-shield-alt"></i>
                  </div>
                  <h4 className="mb-3">Safety Solutions</h4>
                  <p className="fs-6 mb-0">
                    Reliable safety components and systems for protection
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PLC Solutions Section */}
      <section className="py-7 mt-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-5 mb-lg-0" data-aos="fade-right">
              <img
                src={require("../assets/img/products/Schneider/Modicon PLC Solutions Schneider Electric's.png")}
                alt="Schneider Modicon PLCs"
                className="img-fluid rounded-3 shadow"
              />
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <h2 className="display-6 fw-bold mb-4">
                Modicon <span className="text-danger">PLC Solutions</span>
              </h2>
              <p className="fs-6 mb-5">
                Schneider Electric's Modicon PLCs deliver robust, scalable
                automation for industries ranging from manufacturing to
                infrastructure.
              </p>

              <div className="row g-4">
                <div className="col-md-6">
                  <div className="d-flex">
                    <div className="me-4">
                      <div className="icon-md bg-danger bg-opacity-10 text-danger rounded-circle">
                        <i className="fas fa-bolt"></i>
                      </div>
                    </div>
                    <div>
                      <h5 className="fw-bold mb-2">Modicon M221</h5>
                      <p className="fs-6 mb-0 small">
                        Compact PLC ideal for small machines with embedded I/O
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="d-flex">
                    <div className="me-4">
                      <div className="icon-md bg-danger bg-opacity-10 text-danger rounded-circle">
                        <i className="fas fa-network-wired"></i>
                      </div>
                    </div>
                    <div>
                      <h5 className="fw-bold mb-2">Modicon M241</h5>
                      <p className="fs-6 mb-0 small">
                        High-performance PLC with Ethernet and motion control
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="d-flex">
                    <div className="me-4">
                      <div className="icon-md bg-danger bg-opacity-10 text-danger rounded-circle">
                        <i className="fas fa-lock"></i>
                      </div>
                    </div>
                    <div>
                      <h5 className="fw-bold mb-2">Modicon M580</h5>
                      <p className="fs-6 mb-0 small">
                        ePAC with cybersecurity and IIoT capabilities
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="d-flex">
                    <div className="me-4">
                      <div className="icon-md bg-danger bg-opacity-10 text-danger rounded-circle">
                        <i className="fas fa-cloud"></i>
                      </div>
                    </div>
                    <div>
                      <h5 className="fw-bold mb-2">Modicon M262</h5>
                      <p className="fs-6 mb-0 small">
                        IoT-ready controller with cloud connectivity
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* VFD Solutions Section */}
      <section className="py-7 bg-light mt-5">
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-lg-6 order-lg-2 mb-5 mb-lg-0"
              data-aos="fade-left"
            >
              <img
                src={require("../assets/img/products/Schneider/Altivar Drive Solutions Schneider Electric's Altivar drives optimize-2.png")}
                alt="Schneider Altivar Drives"
                className="img-fluid rounded-3 shadow"
              />
            </div>
            <div className="col-lg-6 order-lg-1" data-aos="fade-right">
              <h2 className="display-6 fw-bold mb-4">
                Altivar <span className="text-danger">Drive Solutions</span>
              </h2>
              <p className="fs-6 mb-4">
                Schneider Electric's Altivar drives optimize motor performance
                while reducing energy consumption across industrial
                applications.
              </p>

              <div className="row mb-4">
                <div className="col-12">
                  <div className="card bg-white border-0 shadow-sm mb-3">
                    <div className="card-body">
                      <div className="d-flex align-items-center">
                        <div className="bg-danger bg-opacity-10 text-danger p-2 rounded me-3">
                          <i className="fas fa-cog fs-4"></i>
                        </div>
                        <div>
                          <h5 className="mb-1">Altivar Process ATV900</h5>
                          <p className="fs-6 small mb-0">
                            Advanced drive for process applications with
                            built-in PID
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card bg-white border-0 shadow-sm mb-3">
                    <div className="card-body">
                      <div className="d-flex align-items-center">
                        <div className="bg-danger bg-opacity-10 text-danger p-2 rounded me-3">
                          <i className="fas fa-leaf fs-4"></i>
                        </div>
                        <div>
                          <h5 className="mb-1">Altivar Machine ATV320</h5>
                          <p className="fs-6 small mb-0">
                            Compact drive for basic machine applications
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card bg-white border-0 shadow-sm">
                    <div className="card-body">
                      <div className="d-flex align-items-center">
                        <div className="bg-danger bg-opacity-10 text-danger p-2 rounded me-3">
                          <i className="fas fa-chart-line fs-4"></i>
                        </div>
                        <div>
                          <h5 className="mb-1">Altivar 600</h5>
                          <p className="fs-6 small mb-0">
                            High-performance drive for demanding applications
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HMI/SCADA Section */}
      <section className="py-7 mt-5">
        <div className="container">
          <div className="row justify-content-center mb-7">
            <div className="col-lg-8 text-center" data-aos="fade-up">
              <h2 className="display-6 fw-bold mb-3">
                HMI & <span className="text-danger">SCADA Systems</span>
              </h2>
            </div>
          </div>

          <div className="row g-4">
            <div
              className="col-md-6 col-lg-4"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="card border-0 shadow-sm overflow-hidden">
                <div className=" overflow-hidden">
                  <img
                    src={require("../assets/img/products/Schneider/Magelis HMIs Advanced touchscreen.png")}
                    alt="Magelis HMI"
                    className="img-fluid"
                  />
                </div>
                <div className="card-body">
                  <h4 className="mb-3">Magelis HMIs</h4>
                  <p className="fs-6 mb-4">
                    Advanced touchscreen interfaces with multi-touch capability
                    for industrial environments
                  </p>
                  <ul className="list-unstyled text-muted mb-4">
                    <li className="mb-2 d-flex">
                      <i className="fas fa-check-circle text-danger mt-1 me-2"></i>
                      <span>High-resolution displays</span>
                    </li>
                    <li className="mb-2 d-flex">
                      <i className="fas fa-check-circle text-danger mt-1 me-2"></i>
                      <span>Rugged industrial design</span>
                    </li>
                    <li className="d-flex">
                      <i className="fas fa-check-circle text-danger mt-1 me-2"></i>
                      <span>Seamless PLC integration</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-4"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="card h-100 border-0 shadow-sm overflow-hidden">
                <div className=" overflow-hidden">
                  <img
                    src={require("../assets/img/products/Schneider/EcoStruxure SCADA Powerful supervisory.png")}
                    alt="EcoStruxure SCADA"
                    className="img-fluid"
                  />
                </div>
                <div className="card-body">
                  <h4 className="mb-3">EcoStruxure SCADA</h4>
                  <p className="fs-6 mb-4">
                    Powerful supervisory control and data acquisition system for
                    industrial automation
                  </p>
                  <ul className="list-unstyled text-muted mb-4">
                    <li className="mb-2 d-flex">
                      <i className="fas fa-check-circle text-danger mt-1 me-2"></i>
                      <span>Real-time monitoring</span>
                    </li>
                    <li className="mb-2 d-flex">
                      <i className="fas fa-check-circle text-danger mt-1 me-2"></i>
                      <span>Advanced analytics</span>
                    </li>
                    <li className="d-flex">
                      <i className="fas fa-check-circle text-danger mt-1 me-2"></i>
                      <span>Cloud connectivity</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-4"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div className="card h-100 border-0 shadow-sm overflow-hidden">
                <div className=" overflow-hidden">
                  <img
                    src={require("../assets/img/products/Schneider/AVEVA Edge Scalable HMI.png")}
                    alt="AVEVA Edge"
                    className="img-fluid"
                  />
                </div>
                <div className="card-body">
                  <h4 className="mb-3">AVEVA Edge</h4>
                  <p className="fs-6 mb-4">
                    Scalable HMI/SCADA solution with powerful visualization
                    capabilities
                  </p>
                  <ul className="list-unstyled text-muted mb-4">
                    <li className="mb-2 d-flex">
                      <i className="fas fa-check-circle text-danger mt-1 me-2"></i>
                      <span>HTML5 web-based</span>
                    </li>
                    <li className="mb-2 d-flex">
                      <i className="fas fa-check-circle text-danger mt-1 me-2"></i>
                      <span>Multi-site deployment</span>
                    </li>
                    <li className="d-flex">
                      <i className="fas fa-check-circle text-danger mt-1 me-2"></i>
                      <span>IIoT ready</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* EcoStruxure Section */}
      <section className=" p-5 mt-5  position-relative">
        <div className="position-absolute top-0 start-0 w-100 h-100  opacity-75"></div>
        <div className="container position-relative z-index-1">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-5 mb-lg-0" data-aos="fade-right">
              <h2 className="fs-2 fw-bold text-dark mb-4">
                EcoStruxure <span className="text-danger">Platform</span>
              </h2>
              <p className="fs-6 mb-5">
                Schneider Electric's IoT-enabled architecture delivers
                innovation at every level, from connected products to edge
                control and apps, analytics, and services.
              </p>

              <div className="row g-4">
                <div className="col-md-6">
                  <div className="d-flex">
                    <div className="me-4">
                      <div className="icon-md  text-dark ">
                        <i className="fas fa-plug"></i>
                      </div>
                    </div>
                    <div>
                      <h5 className="text-dark mb-2">Connected Products</h5>
                      <p className="text-dark mb-0 fs-6">
                        Smart sensors, drives, and circuit breakers
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="d-flex">
                    <div className="me-4">
                      <div className="icon-md  text-dark ">
                        <i className="fas fa-server"></i>
                      </div>
                    </div>
                    <div>
                      <h5 className="text-dark mb-2">Edge Control</h5>
                      <p className="text-dark mb-0 fs-6">
                        Local processing and decision-making
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="d-flex">
                    <div className="me-4">
                      <div className="icon-md  text-dark ">
                        <i className="fas fa-cloud"></i>
                      </div>
                    </div>
                    <div>
                      <h5 className="text-dark mb-2">Apps & Analytics</h5>
                      <p className="text-dark-70 mb-0 fs-6">
                        Cloud-based monitoring and optimization
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="d-flex">
                    <div className="me-4">
                      <div className="icon-md text-dark ">
                        <i className="fas fa-shield-alt"></i>
                      </div>
                    </div>
                    <div>
                      <h5 className="text-dark mb-2">Cybersecurity</h5>
                      <p className="text-dark-70 mb-0 fs-6">
                        Built-in protection at every layer
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6" data-aos="fade-left">
              <img
                src={require("../assets/img/products/Schneider/EcoStruxure Platform Schneider Electric's.png")}
                alt="EcoStruxure Architecture"
                className="img-fluid rounded-2"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Industry Applications */}
      <section className="py-7 p-4 bg-light">
        <div className="container">
          <div className="text-center mb-7" data-aos="fade-up">
            <h2 className="display-6 fw-bold mb-4">
              Tailored for Your <span className="text-danger">Industry</span>
            </h2>
          </div>

          <div className="row g-4">
            <div
              className="col-md-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="card h-100 border-0 shadow-sm hover-lift">
                <div className="card-body p-4 text-center">
                  <div className="icon-xl  text-danger  mb-4 mx-auto d-flex align-items-center justify-content-center">
                    <i className="fas fa-industry"></i>
                  </div>
                  <h4 className="mb-3">Manufacturing</h4>
                  <p className="fs-6 mb-0">
                    Automated production lines with predictive maintenance
                  </p>
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="card h-100 border-0 shadow-sm hover-lift">
                <div className="card-body p-4 text-center">
                  <div className="icon-xl  text-danger mb-4 mx-auto d-flex align-items-center justify-content-center">
                    <i className="fas fa-tint"></i>
                  </div>
                  <h4 className="mb-3">Water & Wastewater</h4>
                  <p className="fs-6 mb-0">
                    Smart pumping and treatment solutions
                  </p>
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div className="card h-100 border-0 shadow-sm hover-lift">
                <div className="card-body p-4 text-center">
                  <div className="icon-xl  text-danger  mb-4 mx-auto d-flex align-items-center justify-content-center">
                    <i className="fas fa-oil-can"></i>
                  </div>
                  <h4 className="mb-3">Oil & Gas</h4>
                  <p className="fs-6 mb-0">
                    Rugged solutions for harsh environments
                  </p>
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <div className="card h-100 border-0 shadow-sm hover-lift">
                <div className="card-body p-4 text-center">
                  <div className="icon-xl  text-danger  mb-4 mx-auto d-flex align-items-center justify-content-center">
                    <i className="fas fa-boxes"></i>
                  </div>
                  <h4 className="mb-3">Logistics</h4>
                  <p className="fs-6 mb-0">
                    Automated material handling systems
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-7 p-5 bg-danger text-white">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8" data-aos="zoom-in">
              <h2 className="display-7 fw-bold mb-4">
                Ready to Transform Your Industrial Operations?
              </h2>
              <p className="lead mb-5">
                Our Schneider Electric experts are ready to help you design,
                implement, and optimize your automation solutions.
              </p>
              <div className="d-flex justify-content-center gap-3">
                <Link to="/contact" className="btn btn-light px-5 py-3">
                  Get Started
                </Link>
                <Link
                  to="/products"
                  className="btn btn-outline-light px-5 py-3"
                >
                  Browse All Products
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Schneider;
